
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { PriceAdjustmentModel } from './Entities.Accounting.PriceAdjustment';
import { Model, ModelProperty } from 'models/Model';


export class PriceAdjustmentValueModel extends Model<PriceAdjustmentValueModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'upperBound', type: 'number' },
		{ name: 'targetValue', type: 'number' },
		{ name: 'priceAdjustmentId', type: 'string' },
		{ name: 'priceAdjustment', type: 'PriceAdjustmentModel', isHidden: true, isObject: true, new: () => { return new PriceAdjustmentModel }, properties: () => { return PriceAdjustmentModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public upperBound: number;
	public targetValue: number;
	public priceAdjustmentId?: string;
	public priceAdjustment?: PriceAdjustmentModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.upperBound = 0;
		this.targetValue = 0;
		this.priceAdjustmentId = undefined;
		this.priceAdjustment = undefined;
		
	}
	getProperties(){
		return PriceAdjustmentValueModel.classProperties;
	}
}

